import LoadingSpinner from "../../../common/components/functional/loadingSpinner/LoadingSpinner";
import { SimpleTable } from "../../../common/components/functional/simpleTable/SimpleTable";

import { SimpleTableHeader } from "../../../common/components/functional/simpleTable/SimpleTableHeader";
import { WageReportRowItem } from "./WageReportRowItem";
import { ScrollContainer } from "../styled";

type Props = {
  rowFields: RowField[];
  rows: any[];
  isLoading: boolean;
  selectedItems: string[];
  updateSelected: (itemId: string, selected: boolean) => void;
};

export interface RowField {
  name: string;
  width?: string;
}

export const WageReportsTable = ({
  rowFields,
  rows,
  isLoading,
  selectedItems,
  updateSelected,
}: Props) => {
  return (
    <ScrollContainer
      sx={{
        margin: "-12px",
        marginTop: "4px",
      }}
    >
      {isLoading ? <LoadingSpinner /> : null}
      <SimpleTable
        header={
          <SimpleTableHeader fields={rowFields} translationNs="payslips" />
        }
        items={rows.map((row, index) => (
          <WageReportRowItem
            key={index}
            row={row.fields}
            rowId={row.id}
            selected={selectedItems.includes(row.id)}
            onSelect={updateSelected}
          />
        ))}
      />
    </ScrollContainer>
  );
};
